module.exports = __webpack_public_path__ + "img/ic_dw.944d1dfb.svg";